import { render, staticRenderFns } from "./OrdererBatchListToBill.vue?vue&type=template&id=5fa6248f&lang=pug&"
import script from "./OrdererBatchListToBill.vue?vue&type=script&lang=js&"
export * from "./OrdererBatchListToBill.vue?vue&type=script&lang=js&"
import style0 from "./OrdererBatchListToBill.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OrdererBatchListToBill.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VFlex,
  VLayout,
})
